module.exports = __webpack_public_path__ + "static/media/arribos.a7a2d9f5.svg";